import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  type SxProps,
} from '@mui/material'
import type { ModalState } from './hooks/useModal'

const sx: SxProps = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
}

interface Props {
  modalState: ModalState | null
  closeModal: () => void
}

export function Modal(props: Props) {
  const { modalState, closeModal } = props
  if (!modalState) return null
  const title = modalState.isTransfer ? 'Confirm Transfer' : 'Confirm Delete'

  return (
    <Dialog open fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{modalState.content}</DialogContent>
      <DialogActions>
        <ButtonGroup variant='contained'>
          <Button color='secondary' sx={sx} onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button
            color='primary'
            onClick={() => {
              modalState.onConfirm()
              closeModal()
            }}
            sx={sx}
          >
            Confirm
          </Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  )
}
